// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headline-action[data-v-54c00f8e],.headline-action__head-link[data-v-54c00f8e],.headline-action__img-wrapper[data-v-54c00f8e]{display:flex;align-items:center}.headline-action__img-wrapper[data-v-54c00f8e]{justify-content:center;width:32px;height:32px;margin-right:var(--spaces-s)}.headline-action__img[data-v-54c00f8e]{width:100%;object-fit:contain}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
